import { render, staticRenderFns } from "./UserRestrictions.vue?vue&type=template&id=59e04bae&scoped=true"
import script from "./UserRestrictions.vue?vue&type=script&lang=js"
export * from "./UserRestrictions.vue?vue&type=script&lang=js"
import style0 from "./UserRestrictions.vue?vue&type=style&index=0&id=59e04bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e04bae",
  null
  
)

export default component.exports